/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem } from "@mui/material";
import TicketsListHeader from "../TicketsListHeader/TicketsListHeader";
import { Link } from "react-router-dom";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import TicketsListFilterPopup from "../Popup/TicketsListFilterPopup";
import CreateUpdateTicketPopup from "../Popup/CreateUpdateTicketPopup";
import ClorianImportModal from "../Modals/ClorianImportModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";

//import current date
import { getCurrentDateInString } from "helper/getcurrentdatestring";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

//import images
import { assetImages } from "constants";
//import AddToListModal from "components/Common/Modal/AddToListModal";

const TicketListBody = () => {
  const { t, i18n } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const [tagList, setTagList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ticketsList, setTicketsList] = useState([]);

  //active ticket type tab : "purchase" | "support"
  const [activeTicketType, setActiveTicketType] = useState("purchase");

  //create/update ticket popup state
  const [selectedTicketId, setSelectedTicketId] = useState(null);

  //alert notification state
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedTicketsIds, setSelectedTicketsIds] = useState([]);

  //filter options
  const [filterStartDate, setfilterStartDate] = useState("");
  const [filterEndDate, setfilterEndDate] = useState("");
  const [filterName, setFilterName] = useState("");
  const [filterEmail, setFilterEmail] = useState("");
  const [filterEvent, setFilterEvent] = useState("");
  const [filterLocation, setFilterLocation] = useState("");
  const [filterEntrycode, setFilterEntrycode] = useState("");
  const [filterCompanyIds, setFilterCompanyIds] = useState([]);

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TAGS;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get all tickets
  const getTicketsList = async (isFilter = false) => {
    setRowSelection({});
    setSelectedTicketsIds([]);

    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MY_TICKETS +
        `?userrolestring=${userInfo.role.slug}&tickettype=${activeTicketType}`;

      if (filterStartDate !== "" && filterEndDate !== "") {
        requestUrl += `&filterstartdate=${filterStartDate}&filterenddate=${filterEndDate}`;
      }

      if (filterEvent !== "") {
        requestUrl += `&filterevent=${filterEvent}`;
      }

      if (filterCompanyIds.length > 0) {
        requestUrl += `&filtercompanyids=${filterCompanyIds}`;
      }

      if (filterName !== "") {
        requestUrl += `&clientname=${filterName}`;
      }

      if (filterEmail !== "") {
        requestUrl += `&clientemail=${filterEmail}`;
      }

      if (filterLocation !== "") {
        requestUrl += `&location=${filterLocation}`;
      }

      if (filterEntrycode !== "") {
        requestUrl += `&entrycode=${filterEntrycode}`;
      }

      requestUrl += `&isfilter=${isFilter}`;

      console.log("request url------>", requestUrl);

      const response = await getData(requestUrl);

      console.log("response ------>", response);

      setIsLoading(false);

      if (response.status) {
        setTicketsList(response.data);
        resetFilterData();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for change status
  const changeStatusHandler = async () => {
    // for (let selectedId of selectedCompanyIds) {
    //   try {
    //     let statusData = {
    //       status: "0",
    //     };
    //     let requestUrl =
    //       url.API_BASE_URL +
    //       url.API_UPDATE_COMPANY +
    //       `/${selectedId}` +
    //       ``;
    //     const response = await putData(requestUrl, statusData);
    //     if (response.status) {
    //     }
    //   } catch (error) {
    //     console.log(error.message);
    //   }
    // }
    // getAllCompanyList();
  };

  //refresh record
  const refreshRecords = async () => {
    resetFilterData();
    getTicketsList(false);
  };

  //function for reset filter
  const resetFilterData = () => {
    setfilterStartDate("");
    setfilterEndDate("");
    setFilterEvent("");
    setFilterCompanyIds([]);

    setFilterName("");
    setFilterEmail("");
    setFilterLocation("");
    setFilterEntrycode("");
  };

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  const actionsColumn = {
    accessorKey: "actions",
    header: t("Actions"),
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }) => (
      <button
        className="action_btn_mui"
        data-bs-toggle="offcanvas"
        data-bs-target="#createUpdateTicketOffcanvas"
        aria-controls="createUpdateTicketOffcanvas"
        onClick={() => openEditTicket(row.original._id)}
      >
        <span className="d-block material-symbols-outlined icon-sm">
          edit
        </span>
      </button>
    ),
  };

  const supportColumns = useMemo(
    () => [
      actionsColumn,
      { accessorKey: "customid", header: t("Ticket #") },
      { accessorKey: "subject", header: t("Subject") },
      { accessorKey: "leadname", header: t("Lead") },
      { accessorKey: "leademail", header: t("Lead Email") },
      { accessorKey: "companyname", header: t("Company") },
      { accessorKey: "priority", header: t("Priority") },
      { accessorKey: "stage", header: t("Stage") },
      { accessorKey: "category", header: t("Category") },
      { accessorKey: "ownername", header: t("Owner") },
      { accessorKey: "duedate", header: t("Due Date") },
      { accessorKey: "source", header: t("Source") },
    ],
    [i18n.language]
  );

  const columns = useMemo(
    () => [
      actionsColumn,
      { accessorKey: "customid", header: t("Ticket #") },
      { accessorKey: "event", header: t("Event") },
      { accessorKey: "session_date", header: t("Session Date") },
      { accessorKey: "seat", header: t("Seat") },
      { accessorKey: "sector", header: t("Sector") },
      { accessorKey: "zone", header: t("Zone") },
      { accessorKey: "entrycode", header: t("Entry Code") },
      { accessorKey: "leadname", header: t("Client") },
      { accessorKey: "leademail", header: t("Client Email") },
      { accessorKey: "companyname", header: t("Organizer") },
      { accessorKey: "ownername", header: t("Owner") },
      { accessorKey: "final_price", header: t("Price") },
      { accessorKey: "currency", header: t("Currency") },
      { accessorKey: "client_promotion", header: t("Offer / Promotion") },
      { accessorKey: "stage", header: t("Stage") },
      { accessorKey: "source", header: t("Source") },
    ],
    [i18n.language]
  );

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedTicketsIds(selectedIdsArray);
    } else {
      setSelectedTicketsIds([]);
    }
  }, [rowSelection]);

  useEffect(() => {
    getAllTags();
  }, []);

  useEffect(() => {
    getTicketsList(false);
  }, [activeTicketType]);

  //open the create-ticket popup in "create" mode (clears any selected ticket first)
  const openCreateTicket = () => {
    setSelectedTicketId(null);
  };

  //open the popup in "edit" mode for a given row
  const openEditTicket = (ticketId) => {
    setSelectedTicketId(ticketId);
  };

  //refresh the list after the popup saves a ticket
  const afterTicketPopupClose = () => {
    getTicketsList(false);
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  useEffect(() => {
    if (
      (filterStartDate !== "" && filterEndDate !== "") ||
      filterEvent != "" ||
      filterCompanyIds.length > 0 ||
      filterLocation != "" ||
      filterName != "" ||
      filterEmail != "" ||
      filterEntrycode != ""
    ) {
      getTicketsList(true);
    }
  }, [
    filterStartDate,
    filterEndDate,
    filterEvent,
    filterCompanyIds,
    filterLocation,
    filterName,
    filterEmail,
    filterEntrycode,
  ]);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_TICKET")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            {/* -------- header area ---------- */}
            <TicketsListHeader
              reloadList={refreshRecords}
              changeStatusHandler={changeStatusHandler}
              openCreateTicket={openCreateTicket}
            />

            {/* -------- ticket type tabs -------- */}
            <ul className="nav nav-tabs mb-3">
              <li className="nav-item">
                <Link
                  to="#"
                  className={`nav-link ${
                    activeTicketType === "purchase" ? "active" : ""
                  }`}
                  onClick={() => setActiveTicketType("purchase")}
                >
                  {t("Purchase Tickets")}
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="#"
                  className={`nav-link ${
                    activeTicketType === "support" ? "active" : ""
                  }`}
                  onClick={() => setActiveTicketType("support")}
                >
                  {t("Support Tickets")}
                </Link>
              </li>
            </ul>

            {/* --------- table area --------- */}
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={activeTicketType === "purchase" ? columns : supportColumns} // map columns to be displayed with api data,
                  data={ticketsList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection }} //pass our managed row selection state to the table to use
                  enableColumnOrdering={true}
                />
              </div>
            )}
          </div>
        </section>

        {/* ---------- popups and modals area ------------- */}
        {/* -------- add label modal ------- */}
        <AddLabelModal
          selectedIds={selectedTicketsIds}
          moduleName="tickets"
          afterTagModalClose={getTicketsList}
        />

        {/* ------- filter popup ------- */}
        <TicketsListFilterPopup
          setfilterStartDate={setfilterStartDate}
          setfilterEndDate={setfilterEndDate}
          setFilterEvent={setFilterEvent}
          setFilterCompanyIds={setFilterCompanyIds}
          setFilterName={setFilterName}
          setFilterEmail={setFilterEmail}
          setFilterLocation={setFilterLocation}
          setFilterEntrycode={setFilterEntrycode}
        />

        {/* ------- create / update ticket popup ------- */}
        <CreateUpdateTicketPopup
          selectedTicketId={selectedTicketId}
          afterPopupClose={afterTicketPopupClose}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* ------- clorian import modal ------- */}
        <ClorianImportModal afterImportClose={afterTicketPopupClose} />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                Sorry....! You don't have privilege to see this content
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default TicketListBody;
